import { BaseLayout } from '@uag/react-core';

import { useCopilotLayout } from 'app/modules/wallforming/components/setting-container/hooks/useCopilotLayout';
import { SettingContainer } from 'app/modules/wallforming/components/setting-container/SettingContainer';

export const CataloguePage = () => {
    const { layout: copilotLayout } = useCopilotLayout();
    return (
        <div className="max-h-screen max-w-screen overflow-hidden">
            <BaseLayout
                className="bg-background-gray-ultra-ultra-light overflow-hidden"
                environment={import.meta.env.VITE_ENVIRONMENT}
                innerClassName="h-full w-full overflow-hidden"
                showFooter={true}
                versionNumber={APP_VERSION}
                withCookieBanner={false}
            >
                <div className="w-full h-full overflow-hidden">
                    <SettingContainer copilotLayout={copilotLayout} />
                </div>
            </BaseLayout>
        </div>
    );
};
